<div class="notification" (click)="action()">
    <div class="identify">
        <mat-icon>book</mat-icon>
    </div>
    <div class="content">
        {{ data.conteudo }}
    </div>
    <div class="action">
        <button mat-icon-button (click)="$event.stopPropagation(); close()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
</div>
